import script from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=302332c5&scoped=true&lang=css"
import "./SimpleKeyboard.vue?vue&type=style&index=1&id=302332c5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302332c5"]])

export default __exports__